const AcceptedFileEnum = {
  SPREADSHEET_ACCEPTED: '.xls, .xlsx, .csv',
  DOCUMENT_ACCEPTED: '.pdf, .gif, .jpg, .png, .bmp',
};

export default AcceptedFileEnum;
